import React, { PropTypes } from 'react';
import moment from 'moment';
import truncate from 'lodash/truncate';
import ProjectLink from 'common/containers/project_link';
import StarRating from 'common/components/star_rating';

const NameDenseItem = ({ item }) => {
  const revision = item.revisions[0];
  const project = {
    id: item.project,
    slug: item.project_slug,
    sub_category: item.project_sub_category,
    title: item.project_title
  };

  return (
    <tr>
      <td className="entry-name">
        <ProjectLink project={project} append={`entry/${item.id}/`} target="_blank">
          <span className="show-for-small-only">{ truncate(revision.name, { length: 25 }) }</span>
          <span className="hide-for-small-only">{ revision.name }</span>
        </ProjectLink>
      </td>
      <td className="hide-for-small-only">
        <ProjectLink project={project} append="your-entries" target="_blank">
          { truncate(project.title, { length: 30 }) }
        </ProjectLink>
      </td>
      <td className="hide-for-small-only">{ moment(revision.created_at).fromNow() }</td>
      <td>
        { item.withdrawn && <span className="message">withdrawn</span> }
        { item.eliminated && <span className="message">eliminated</span> }
        <StarRating key={item.id} readonly={true} initialRate={revision.score || 0} />
      </td>
    </tr>
  );
}

NameDenseItem.propTypes = {
  item: PropTypes.object.isRequired,
};

export default NameDenseItem;



// WEBPACK FOOTER //
// ./profile/components/your_entries/name_dense_item.jsx